module.exports = __webpack_public_path__ + "static/media/gems-informatics.913e5d50.png";